// src/components/Chat/Message/Chart/ScatterChartComponent.tsx
import React from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as TooltipsChart,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Typography } from "@mui/material";

const ScatterChartComponent: React.FC<{
  data: Array<{ label: string; [key: string]: number | string }>;
  name: string;
  theme: any;
}> = ({ data, name, theme }) => {
  // Extract numeric keys for scatter plot axes (exclude "label")
  const scatterKeys = Object.keys(data[0]).filter(
    (key) => key !== "label" && typeof data[0][key] === "number"
  );

  const getColor = (index: number) => {
    const colors = [
      theme.palette.primary.main,
      theme.palette.secondary.main,
      theme.palette.success.main,
      theme.palette.error.main,
      theme.palette.info.main,
      theme.palette.warning.main,
    ];
    return colors[index % colors.length];
  };

  return (
    <>
      <Typography sx={{ mb: 2, width: "100%", textAlign: "center" }}>
        {name}
      </Typography>
      <ResponsiveContainer width="100%" height={240}>
        <ScatterChart>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            type="number"
            dataKey={scatterKeys[0]} // Dynamically use the first numeric key
            name={scatterKeys[0]} // Name for x-axis
            tick={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
              fill: theme.palette.text.primary,
            }}
          />
          <YAxis
            type="number"
            dataKey={scatterKeys[1]} // Dynamically use the second numeric key
            name={scatterKeys[1]} // Name for y-axis
            tick={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
              fill: theme.palette.text.primary,
            }}
          />
          <TooltipsChart
            cursor={{ strokeDasharray: "3 3" }}
            contentStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            }}
            itemStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
              color: theme.palette.text.primary,
            }}
            labelStyle={{
              color: theme.palette.text.primary,
            }}
            formatter={(value, name, props) =>
              `${name}: ${value}, Label: ${props.payload.label}`
            }
          />
          <Legend
            wrapperStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
            }}
          />
          <Scatter
            name={`${scatterKeys[1]} vs ${scatterKeys[0]}`} // Scatter name for legend
            data={data} // Use original data without transformation
            fill={getColor(0)}
            fillOpacity={0.6}
            stroke={getColor(0)}
          />
        </ScatterChart>
      </ResponsiveContainer>
    </>
  );
};

export default ScatterChartComponent;
